module.exports = __webpack_public_path__ + "static/media/Hitachi -Post 309x424px 02-min.cc06c578.jpg";